import { render, staticRenderFns } from "./IndicatorManagement.vue?vue&type=template&id=49788f74"
import script from "./IndicatorManagement.vue?vue&type=script&lang=js"
export * from "./IndicatorManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports